'use client';

type Props = {
  title: string;
  closeModal: () => void;
};

export default function PostErrorModal({ title, closeModal }: Props) {
  return (
    <div className="fixed left-0 top-0 z-[102] h-full w-full animate-fade-in pt-[50px]">
      <div
        className="fixed left-0 top-0 z-[-1] h-full w-full bg-black bg-opacity-50"
        onClick={closeModal}
      />
      <div className="fixed left-[50%] top-[50%] z-[101] mx-auto flex w-[calc(100vw-72px)] max-w-[425px] translate-x-[-50%] translate-y-[-50%] flex-col gap-4  rounded-[12px] border   bg-background bg-neutral-100 p-6 text-center shadow-lg duration-200 sm:w-[calc(100vw-32px)]">
        <div className="!text-center text-[18px] font-bold">{title}エラー</div>
        <p>{title}に失敗しました。</p>
        <p>
          しばらく時間を置いてから
          <br />
          再度お試しください。
        </p>
        <div className="text-center">
          <button
            onClick={closeModal}
            className="rounded-[25px] border-2 border-solid border-primary px-[25px] py-[8px] text-[14px]"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
